import isPlainObject from 'lodash.isplainobject';
export function isObject(obj) {
    return isPlainObject(obj);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwaW5nLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2xpYi91dGlscy90eXBpbmcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxhQUFhLE1BQU0sc0JBQXNCLENBQUE7QUFFaEQsTUFBTSxVQUFVLFFBQVEsQ0FBQyxHQUFhO0lBQ3BDLE9BQU8sYUFBYSxDQUFDLEdBQUcsQ0FBQyxDQUFBO0FBQzNCLENBQUMifQ==